/**
 * UnauthorizedPage
 *
 * Displayed when user tries to access a route they don't have permission for
 */

import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { Lock as LockIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useRBAC } from '../contexts/RBACContext';

const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();
  const { claims } = useRBAC();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="60vh"
      p={3}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 500,
          textAlign: 'center'
        }}
      >
        <Box display="flex" justifyContent="center" mb={3}>
          <LockIcon sx={{ fontSize: 80, color: 'error.main' }} />
        </Box>

        <Typography variant="h4" gutterBottom>
          Accès non autorisé
        </Typography>

        <Typography variant="body1" color="text.secondary" paragraph>
          Vous n'avez pas les permissions nécessaires pour accéder à cette page.
        </Typography>

        {claims && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Votre rôle actuel : <strong>{claims.role}</strong>
          </Typography>
        )}

        <Box display="flex" gap={2} justifyContent="center">
          <Button variant="outlined" onClick={handleGoBack}>
            Retour
          </Button>
          <Button variant="contained" onClick={handleGoHome}>
            Aller à l'accueil
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default UnauthorizedPage;
